import { Box, Grid } from '@mui/material';
import { Filter } from '../../filters/FilterTypes';
import LeadSearch from '../../filters/leads/LeadSearch';
import LeadDataGrid from './LeadDataGrid';
import { v4 as uuid } from 'uuid';
import React, { useState } from 'react';
import ExcelImportDialog from './ExcelImportDialog';
import OptionsLoader from '../../common/OptionsLoader';
import ExcelImportStore from './ExcelImportStore';
import { Session } from './LeadDataGridStore';
import LeadImportList from '../../../v2/features/LeadImport/LeadImportList/LeadImportList';
import { StageLeadSession } from '../../../v2/features/LeadImport/LeadImportList/types/types';
import useApplication from '../../../v2/hooks/useApplication.hooks';
import { client } from '../../../utils/axios-client';
import NewResearchDialog from './NewResearchDialog';

const LeadEditorPage = () => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [researchDialogOpen, setResearchDialogOpen] = useState(false);
    const [showImportGrid, setShowImportGrid] = useState(false);
    const { isLoading, setIsLoading } = useApplication();

    const openImportDialog = () => {
        ExcelImportStore.update((s) => {
            s.session = {
                importType: 'ImportToSprint',
                name: '',
                sessionId: uuid(),
            } as Session;
            s.leads = [];
        });

        setDialogOpen(true);
    };

    const onCloseGrid = () => {
        setShowImportGrid(false);
    };

    const onOpenSession = async (row: StageLeadSession) => {
        setIsLoading(true);
        try {
            //const response = await client.get(`/api/leadresearch/get/${row.id}`);

            ExcelImportStore.update((s) => {
                s.session = {
                    importType: row.importType,
                    name: row.name,
                    sessionId: row.id,
                    startDate: row.startDate,
                    cadenceId: row.cadenceId,
                    cadenceName: row.candeceName,
                    sprintId: row.sprintId,
                    sprintName: row.sprintName,
                    customerId: row.customerId,
                    customerName: row.customerName,
                } as Session;
                s.leads = [];
            });

            setShowImportGrid(true);
        } finally {
            setIsLoading(false);
        }
    };

    const openResearch = () => {
        ExcelImportStore.update((s) => {
            s.session = {
                importType: 'ImportToSprint',
                name: '',
                sessionId: uuid(),
            } as Session;
            s.leads = [];
        });

        setResearchDialogOpen(true);
    };

    return (
        <OptionsLoader>
            {!showImportGrid && (
                <LeadImportList
                    onOpenImportDialog={openImportDialog}
                    onOpenSession={onOpenSession}
                    openResearch={openResearch}
                />
            )}

            <ExcelImportDialog
                open={dialogOpen}
                onClose={(importing: boolean) => {
                    setDialogOpen(false);
                    setShowImportGrid(importing);
                }}
            />

            <NewResearchDialog
                open={researchDialogOpen}
                onClose={(importing: boolean) => {
                    setResearchDialogOpen(false);
                    setShowImportGrid(importing);
                }}
            />

            {showImportGrid && (
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column', height: '100%' }}>
                    <div style={{ flexGrow: 2 }}>
                        <LeadDataGrid onClose={onCloseGrid} />
                    </div>
                </div>
            )}
        </OptionsLoader>
    );
};

export { LeadEditorPage };
export default LeadEditorPage;
